import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  IFilter,
  IQueryParam,
  ICliente,
  ICategoriaEvento,
  IPopulate,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import {
  HelperService,
  Modulo,
} from '../../../../../auxiliares/servicios/helper.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { CategoriaEventosService } from '../../../../../auxiliares/servicios/http/categoria-eventos.service';
import { CrearEditarCategoriaEventoComponent } from '../crear-editar-categoria-evento/crear-editar-categoria-evento.component';
import { LoginService } from '../../../../login/login.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';

import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import { colorMuestraHtml, estadoHtml } from '../../../../../auxiliares/tabla/celdas';

@Component({
  selector: 'app-listado-categorias-eventos',
  templateUrl: './listado-categorias-eventos.component.html',
  styleUrl: './listado-categorias-eventos.component.scss',
  standalone: false,
})
export class ListadoCategoriasEventosComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(CategoriaEventosService);
  private formularios = inject(FormularioDialogService);

  public clientePropio?: ICliente = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoCategoriasEventosComponent';
  public datos?: ICategoriaEvento[];
  public totalCount = 0;
  public columnas?: IColumnas<ICategoriaEvento>[];
  //Subs
  public codigosEventos$?: Subscription;

  //
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso(
      'Administración - Crear categorias eventos',
    ),
    tooltip: 'Crear categoría',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['nombre'],
  };
  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public global: IFiltroTabla = {
    elementos: [
      { label: 'Global', value: true },
      { label: 'No global', value: false },
    ],
    filter: {
      field: 'global',
    },
    selectLabel: 'label',
    selectValue: 'value',
    label: 'Global',
    tipo: 'select',
  };
  public default: IFiltroTabla = {
    elementos: [
      { label: 'Por defecto', value: true },
      { label: 'No por defecto', value: false },
    ],
    filter: {
      field: 'default',
    },
    selectLabel: 'label',
    selectValue: 'value',
    label: 'Por defecto',
    tipo: 'select',
  };
  // Opciones del filtro Módulo con el/los módulo(s) que las habilitan. 'Otro' es
  // bucket genérico → siempre. Nivel 0 ve todas.
  private moduloOpciones: { value: string; modulos: Modulo[] }[] = [
    { value: 'Activo', modulos: ['Activos'] },
    { value: 'Vehiculo', modulos: ['Vehículos'] },
    { value: 'Alarma', modulos: ['Alarmas'] },
    { value: 'Luminaria', modulos: ['Luminarias'] },
    { value: 'Sistema', modulos: ['Administración'] },
    { value: 'Tracker', modulos: ['Activos', 'Vehículos', 'Colectivos'] },
    { value: 'Dashcam', modulos: ['Activos', 'Vehículos', 'Colectivos'] },
  ];
  public modulo: IFiltroTabla = {
    elementos: [],
    filter: {
      field: 'modulo',
    },
    label: 'Módulo',
    tipo: 'select',
  };
  public filtros: IFiltroTabla[] = [this.global, this.default, this.modulo];
  //Query

  public filter: IFilter<ICategoriaEvento> = {};
  public populate: IPopulate[] = [
    {
      path: 'cliente',
      select: 'nombre',
    },
  ];
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    populate: JSON.stringify(this.populate),
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };
  // Listars

  public async listar(): Promise<void> {
    this.codigosEventos$?.unsubscribe();
    this.codigosEventos$ = this.lista2
      .categoriaEventos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.datos = data.datos;
      });
  }

  // Acciones
  public crear() {
    const res = this.formularios.abrir(CrearEditarCategoriaEventoComponent, {
      tamano: 'mediano',
    });
    if (res) {
      res.afterClosed().subscribe(async () => {
        await this.listar();
      });
    }
  }

  public async editar(tipoEvento: ICategoriaEvento) {
    const res = this.formularios.abrir(CrearEditarCategoriaEventoComponent, {
      tamano: 'mediano',
      data: tipoEvento,
    });
    if (res) {
      res.afterClosed().subscribe(async () => {
        await this.listar();
      });
    }
  }

  public async eliminar(tipoevento: ICategoriaEvento) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés eliminar la categoría ${tipoevento.nombre}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(tipoevento._id!);
      this.helper.notifSuccess('Eliminación correcta');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<ICategoriaEvento>[] = [
      // Nombre, con el color de la categoría y si es global o por defecto
      {
        header: {
          label: 'Nombre',
          sortable: true,
          sort: 'nombre',
        },
        row: {
          html: (dato) => {
            let html = `<div class="tabla-celda-col">`;
            html += `<span class="tabla-principal">${estadoHtml({ texto: dato.nombre || '', tono: 'neutro', color: dato.color })}</span>`;
            const marcas: string[] = [];
            if (dato.global) marcas.push('Global');
            if (dato.default) marcas.push('Por defecto');
            if (marcas.length) {
              html += `<span class="tabla-secundario">${marcas.join(' · ')}</span>`;
            }
            html += `</div>`;
            return html;
          },
        },
      },
      // Módulo
      {
        header: {
          label: 'Módulo',
          sortable: true,
        },
        row: {
          field: 'modulo',
          noData: 'Sin módulo',
        },
      },
      // Prioridad
      {
        header: {
          label: 'Prioridad',
          sortable: true,
        },
        row: {
          field: 'prioridad',
          noData: 'Sin prioridad',
        },
      },
      // Color: código del color (el color se ve en el badge del nombre)
      {
        header: {
          label: 'Color',
        },
        row: {
          html: (dato) => {
            if (!dato.color) return '';
            return colorMuestraHtml(dato.color);
          },
          noData: 'Sin color',
        },
      },
      // Notificación push (dato: Sí/No)
      {
        header: {
          label: 'Notificación push',
        },
        row: {
          parse: (dato) => (dato.notificar ? 'Sí' : 'No'),
        },
      },
      // Requiere atención (dato: Sí/No)
      {
        header: {
          label: 'Requiere atención',
        },
        row: {
          parse: (dato) => (dato.atender ? 'Sí' : 'No'),
        },
      },
      // No derivar (dato: Sí/No)
      {
        header: {
          label: 'No derivar',
        },
        row: {
          parse: (dato) => (dato.noDerivar ? 'Sí' : 'No'),
        },
      },
      // Sonido
      {
        header: {
          label: 'Sonido',
          sortable: true,
        },
        row: {
          field: 'sonido',
          noData: 'Sin sonido seleccionado',
        },
      },
    ];
    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }
    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(
                'Administración - Editar categorias eventos',
              ) ||
              (dato.global && !this.helper.esNivel0()),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: (dato) =>
              !this.helper.tienePermiso(
                'Administración - Eliminar categorias eventos',
              ) ||
              (dato.global && !this.helper.esNivel0()),
          },
        ],
      },
    });

    this.columnas = columnas;
  }
  // Hooks

  async ngOnInit() {
    // Opciones de Módulo solo de los módulos que tiene el usuario (+ 'Otro').
    this.modulo.elementos = [
      ...this.moduloOpciones
        .filter((o) => this.helper.tieneModulo(...o.modulos))
        .map((o) => o.value),
      'Otro',
    ];
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  async ngOnDestroy() {
    this.codigosEventos$?.unsubscribe();
  }
}
